module.exports = __webpack_public_path__ + "img/img_banner_retail@3x.8da0d104.png";